// Monta la sesión de documentos una vez por sesión de portal.
// No renderiza nada y no bloquea el render del dashboard: la credencial recién
// se necesita cuando el usuario hace clic en un PDF.

import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ensureDocsSession } from '../lib/docsSession';

export default function DocsSession() {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) return;

    ensureDocsSession(getAccessTokenSilently);

    // Al volver a la pestaña, reemitir: cubre el caso de la laptop suspendida
    // durante horas, donde el timer de renovación no corrió a tiempo.
    const onFocus = () => ensureDocsSession(getAccessTokenSilently);
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [isAuthenticated, getAccessTokenSilently]);

  return null;
}
